import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomModal from '../../Modal';
import FormGroup from '../../FormGroup';
import DynamicSelectSegment from '../../DynamicSelectSegment';
import CustomNotify from "../../Notify";
import ClipboardCopy from '../../../helpers/ClipboardCopy';
import config, { statuses, metaUtmParams } from '../../../config';
import Button from "../../Button";
import Collapse, { Panel } from 'rc-collapse';
import Icon from '../../Icon';
import CustomTooltip from '../../Tooltip';

const promocode = 'promocode';

const ConstructorBanners = ({
    visible: propVisible,
    banner: propBanner,
    links: propLinks,
    goalEntries: propGoalEntries,
    publisherId: propPublisherId,
    publisherIsReferral: propPublisherIsReferral,
    offer: propOffer,
    onClose: propOnClose,
    onSave: propOnSave,
    t
}) => {
    const [state, setState] = useState({
        visible: propVisible,
        banner: propBanner,
        links: propLinks,
        goalEntries: propGoalEntries,
        publisherId: propPublisherId,
        publisherIsReferral: propPublisherIsReferral,
        offer: propOffer,
            metaParams: {},
            currentLink: {},
            selfieLink: '',
        link: '',
        creativeType: 'banner',
        creativeId: propBanner?.id,
        goalEntryId: null
    });

    const resultRef = useRef(null);
    const staticNames = t?.constructors || {};
    const linkId = state.currentLink?.id;
    const currentLinkValues = useMemo(() => (linkId ? [linkId] : []), [linkId]);


    const getFirstGoal = useCallback(() => {
        let goal = state.goalEntries ? (state.goalEntries.find(g => g.access_granted) || {}) : {};
        return goal.id;
    }, [state.goalEntries]);

    const getMetaParams = useCallback(() => {
        let metaParams = Object.keys(state.metaParams).map((paramKey) => {
            let value = state.metaParams[paramKey];
            return value ? paramKey + '=' + value : ''
        });

        metaParams = metaParams.filter(n => {
            return n && n !== '&'
        });
        return metaParams.length ? '&' + metaParams.join('&') : '';
    }, [state.metaParams]);

    const getLinkParams = useCallback(() => {
        let linkIdParam = '?l=' + state.currentLink.id,
            selfieLink = state.selfieLink;

        return (selfieLink && state.currentLink.selfie_link) ? linkIdParam + '&sl=' + encodeURIComponent(selfieLink) : linkIdParam;
    }, [state.currentLink, state.selfieLink]);

    const getResultLink = useCallback((promo, publisherIsReferral = false) => {
        let metaParams = getMetaParams();

        if(promo.params) {
            metaParams = '';
            let promoParams = typeof promo.params === "string" ? JSON.parse(promo.params) : promo.params;

            if(promoParams !== undefined && promoParams !== null) {
                Object.keys(promoParams).map((key) => {
                    if (promoParams[key].length > 0) {
                        metaParams = metaParams + '&' + key + '=' + promoParams[key];
                    }
                });
            }
        }

        let advertiserIsReferral = false,
            offerIsReferral = false,
            currentGoalEntryId = state.goalEntryId;
        if (currentGoalEntryId && state.goalEntries.length) {
            state.goalEntries.forEach(function(goalEntry) {
                if (goalEntry.id === currentGoalEntryId) {
                    advertiserIsReferral = goalEntry.offer.advertiser.referral_advertiser;
                    offerIsReferral = goalEntry.offer.referral_offer;
                }
            });
        }

        metaParams = metaParams + '&creative_type=' + state.creativeType + '&creative_id=' + state.creativeId;

        if (publisherIsReferral && advertiserIsReferral && offerIsReferral) {
            metaParams += '&param8=referer_id';
        }

        return `${state.offer.tds_domain}/${state.publisherId}/${state.goalEntryId}${getLinkParams()}${metaParams}`;
    }, [state, getMetaParams, getLinkParams]);

    const getCode = useCallback(() => {
        return `<a href="${getResultLink(state.banner, state.publisherIsReferral)}" title=""><img src="${state.banner.url}" width="${state.banner.width}" height="${state.banner.height}" alt="" /></a>`;
    }, [state.banner, state.publisherIsReferral, getResultLink]);

    const getAllowChar = useCallback(() => {
        return /[^\da-zA-Z.%_{}\[\]#$\-]/g;
    }, []);

    const onErrorMsg = useCallback((key) => {
        CustomNotify((t && t.constructors && t.constructors[key]) || '', 'error');
    }, [t]);

    const setParam = useCallback((e) => {
        if (e.target.value.replace(getAllowChar(), '') !== e.target.value) {
            onErrorMsg('notAllowCharMsg');
            return;
        }

        const placeholder = e.target.placeholder || '';
        const inputValue = e.target.value || '';

        setState(prevState => {
            let metaParams = { ...prevState.metaParams };
            let banner = { ...prevState.banner };

            if (typeof banner.params === "string") {
                try {
                    banner.params = JSON.parse(banner.params);
                } catch (error) {
                    banner.params = {};
                }
            }

            if (!banner.params || typeof banner.params !== "object") {
                banner.params = {};
            }

            metaParams[placeholder] = inputValue;
            banner.params[placeholder] = inputValue;

            return {
                ...prevState,
                metaParams: metaParams,
                banner: banner
            };
        });
    }, [getAllowChar, onErrorMsg]);

    const onLinkChange = useCallback((item) => {
        setState(prevState => ({
            ...prevState,
            currentLink: item
        }));
    }, []);

    const setSelfieLink = useCallback((e) => {
        setState(prevState => ({
            ...prevState,
            selfieLink: e.target.value
        }));
    }, []);

    const onGoalChange = useCallback((e) => {
        setState(prevState => ({
            ...prevState,
            goalEntryId: e.target.value
        }));
    }, []);

    const onCopyButtonClick = useCallback(() => {
        ClipboardCopy.copy(resultRef.current);
        CustomNotify((t && t.constructors && t.constructors.copyBannerBuffer) || '');

        propOnSave(state, t || {}, () => {}, () => {});
    }, [state, t, propOnSave]);

    const getStatusIcon = useCallback(() => {
        const dataGoal = state.goalEntries.filter((item) => item.id === state.goalEntryId)[0] || {};

        return dataGoal.status === statuses.paused
            ? (
                <CustomTooltip id={`icon-paused-constructor`} tooltip={(t && t.offersPage && t.offersPage.offer && t.offersPage.offer.paused) || ''}>
                    <Icon name={`link-construrtor__label-icon fa fa-pause-circle`} />
                </CustomTooltip>
            )
            : null;
    }, [state.goalEntries, state.goalEntryId, t]);

    const renderGoalEntries = useCallback(() => {
        return (
            <div className="form-group">
                <label className="control-label">{(t && t.constructors && t.constructors.goal) || ''}</label>
                {getStatusIcon()}
                <select onChange={onGoalChange}
                        value={state.goalEntryId || ''}
                        className="form-control"
                >
                    {
                        state.goalEntries.map((goal, key) => {
                            return <option key={key} disabled={!goal.access_granted} value={goal.id}>{goal.goal.title}</option>
                        })
                    }
                </select>
            </div>
        );
    }, [t, getStatusIcon, onGoalChange, state.goalEntryId, state.goalEntries]);

    const renderParams = useCallback((promoType) => {
        return (
            <div className="form-group">
                <label className="control-label bold">{(t && t.constructors && t.constructors.utm) || ''}</label>
                <div className="form-row">
                    {metaUtmParams.map(key => {
                        let value = state.metaParams[key] || '';
                        return (
                            <input
                                type="text"
                                maxLength="50"
                                onChange={setParam}
                                placeholder={key}
                                className="form-control"
                                value={value}
                                key={key}
                            />
                        )
                    })}
                </div>
            </div>
        );
    }, [t, state.metaParams, setParam]);

    const renderSubMetaParams = useCallback((promoType) => {
        return (
            <div className="form-group">
                <label className="control-label bold">{(t && t.constructors && t.constructors.subaccount) || ''}</label>
                <div className="form-row">
                    {Array.from(Array(config.metaParamsCount).keys()).map((index) => {
                        let value = state.metaParams['param' + (index + 1)] || '';
                        return (
                            <input type="text" maxLength="50"
                               onChange={setParam}
                               placeholder={'param' + (index + 1)}
                               className="form-control"
                               value={value}
                               key={index}
                            />
                        )
                    })}
                </div>
            </div>
        )
    }, [t, state.metaParams, setParam]);

    const renderSelfieLink = useCallback(() => {
        return (
            <React.Fragment>
                <div className="hr-line-dashed" />
                <FormGroup
                    label={'Selfie link'}
                >
                    <input
                        type="text"
                        maxLength="255"
                        value={state.selfieLink}
                        onChange={setSelfieLink}
                        placeholder="Selfie link"
                        className="form-control"
                    />
                </FormGroup>
            </React.Fragment>
        );
    }, [state.selfieLink, setSelfieLink]);

    useEffect(() => {
        const isChangeOffer = state.offer !== propOffer;
        const isChangeBanner = state.banner !== propBanner;
        
        let newState = {
            visible: propVisible,
            banner: propBanner,
            links: propLinks,
            goalEntries: propGoalEntries,
            offer: propOffer,
            creativeType: 'banner',
            creativeId: propBanner?.id,
            goalEntryId: getFirstGoal()
        };

        if (isChangeOffer || isChangeBanner) {
            newState.selfieLink = '';
            newState.metaParams = {};
            newState.currentLink = propOffer?.default_link || propLinks?.[0] || {};
        }

        setState(prevState => ({
            ...prevState,
            ...newState
        }));
    }, [propVisible, propBanner, propLinks, propGoalEntries, propOffer, getFirstGoal]);

    if (!state.links && state.visible) {
        CustomNotify(staticNames.cantCreateUrlForCreativeNoLinksAvailable, 'error');
        return '';
        }

        return (
            <CustomModal
            title={staticNames.createBanner}
            confirmName={staticNames.copy}
            visible={state.visible}
            onClose={propOnClose}
                bsSize={'sm'}
            onConfirm={onCopyButtonClick}
            >
            {renderGoalEntries()}

                <FormGroup
                label={staticNames.link}
                >
                    <DynamicSelectSegment
                        segment={'Link'}
                    values={currentLinkValues}
                        extraParams={{
                        offer_ids: state.offer.id
                        }}
                    onAction={onLinkChange}
                    />
                </FormGroup>

            {renderParams('banner')}

            {renderSubMetaParams('banner')}
            {state.currentLink.selfie_link
                ? renderSelfieLink()
                    : null
                }

                <FormGroup
                label={staticNames.resultCode}
                >
                    <textarea
                        className="form-control"
                        readOnly={true}
                    value={getCode()}
                    ref={resultRef}
                        style={{minHeight: 100, maxHeight: 160}}
                    />
                </FormGroup>
            </CustomModal>
    );
    };

ConstructorBanners.propTypes = {
    visible: PropTypes.bool,
    banner: PropTypes.object,
    offer: PropTypes.object,
    goalEntries: PropTypes.array,
    publisherId: PropTypes.string,
    publisherIsReferral: PropTypes.bool,
    links: PropTypes.array,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    t: PropTypes.object
};

ConstructorBanners.defaultProps = {
    visible: false,
    banner: {},
    offer: {},
    goalEntries: [],
    publisherId: '',
    publisherIsReferral: false,
    links: [],
    onClose: () => {},
    onSave: () => {}
};

export default withTranslation(ConstructorBanners);
